import { mst } from '@gomi/utils';
import { Instance, SnapshotIn, types } from 'mobx-state-tree';

import { ALL } from '@/constant';
import { CountryEnum } from '@/generated/graphql-react-query';

const IDENTIFIER = 'brandListModel';

export const country = { ...CountryEnum, [ALL]: ALL };
export type TCountry = keyof typeof country;

export type TFilterControlKeys = 'companyId' | 'countryId' | 'userIds' | 'searchKeyword';

const FilterControl = types.model({
  countryId: mst.types.enumeration<TCountry>(country),
  searchKeyword: types.string,
});

export type TFilterControl = Instance<typeof FilterControl>;

export const model = types
  .model(IDENTIFIER, {
    identifier: IDENTIFIER,
    filterControl: FilterControl,
  })
  .actions((self) => ({
    onChangeFilterControl(controlType: TFilterControlKeys, value: string) {
      self.filterControl = { ...self.filterControl, [controlType]: value };
    },
  }));

/** 초기화 값 */
const defaultValue: SnapshotIn<typeof model> = {
  filterControl: {
    countryId: ALL,
    searchKeyword: '',
  },
};

/** create or initialize */
const create = model.create(defaultValue);

const brandManagementStore = {
  create,
  defaultValue,
  model,
};

/** 모델 타입 */
export type IBrandListModelType = Instance<typeof model>;

export default brandManagementStore;
